import { sha1_asm } from './sha1.asm';
import { Hash } from '../hash';
import { _heap_init } from '../../other/utils';
export const _sha1_block_size = 64;
export const _sha1_hash_size = 20;
const heap_pool = [];
const asm_pool = [];
export class Sha1 extends Hash {
    constructor() {
        super();
        this.NAME = 'sha1';
        this.BLOCK_SIZE = _sha1_block_size;
        this.HASH_SIZE = _sha1_hash_size;
        this.acquire_asm();
    }
    acquire_asm() {
        if (this.heap === undefined || this.asm === undefined) {
            this.heap = heap_pool.pop() || _heap_init();
            this.asm = asm_pool.pop() || sha1_asm({ Uint8Array: Uint8Array }, null, this.heap.buffer);
            this.reset();
        }
        return { heap: this.heap, asm: this.asm };
    }
    release_asm() {
        if (this.heap !== undefined && this.asm !== undefined) {
            heap_pool.push(this.heap);
            asm_pool.push(this.asm);
        }
        this.heap = undefined;
        this.asm = undefined;
    }
    static bytes(data) {
        return new Sha1().process(data).finish().result;
    }
}
Sha1.NAME = 'sha1';
Sha1.heap_pool = [];
Sha1.asm_pool = [];
Sha1.asm_function = sha1_asm;
